import { render, staticRenderFns } from "./BoxCard.vue?vue&type=template&id=05f4c7b0&scoped=true&"
import script from "./BoxCard.vue?vue&type=script&lang=js&"
export * from "./BoxCard.vue?vue&type=script&lang=js&"
import style0 from "./BoxCard.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"
import style1 from "./BoxCard.vue?vue&type=style&index=1&id=05f4c7b0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f4c7b0",
  null
  
)

export default component.exports